import { Alert, Box, BoxProps, Button, List, ListItem, ListItemText, Skeleton, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import Link from '../Link';
import { Props as EntityItemProps } from './EntityItem';
import { Icon } from '@iconify/react';
import { EntityItem } from '.';

export interface Props extends Omit<BoxProps, 'onClick' | 'children'> {
  loading?: boolean;
  items?: EntityItemProps[];
  item?: FC<any>;
  newButtonContent?: ReactNode;
  onClick?: EntityItemProps['onClick'];
  actions?: EntityItemProps['actions'];
  disableCreate?: boolean;
  title?: string;
  toNew?: string;
  gap?: CSSStyleDeclaration['gap'];
}

const EntityList: FC<Props> = ({
  loading,
  toNew,
  title,
  gap,
  items,
  item: Item = EntityItem,
  newButtonContent,
  actions,
  disableCreate,
  onClick,
  ...props
}) => {
  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography mb={1} variant="h2">
          {title}
        </Typography>

        {!disableCreate && (
          <Link to={toNew || 'new'}>
            <Button
              startIcon={<Icon icon="ic:baseline-plus" height="20" />}
              variant="outlined"
              size="small"
              color="primary"
            >
              {newButtonContent ?? 'New'}
            </Button>
          </Link>
        )}
      </Box>

      <Box display="flex" flexDirection="column" gap={gap}>
        {loading && (
          <>
            <ListItem disableGutters>
              <Skeleton variant="rectangular" width="100%" height={50} />
            </ListItem>
            <ListItem disableGutters>
              <Skeleton variant="rectangular" width="100%" height={50} />
            </ListItem>
          </>
        )}
        {!loading &&
          items?.map((item, i) => <Item actions={actions} onClick={(e) => onClick?.(item, e)} key={i} {...item} />)}
        {!items?.length && !loading && (
          <ListItem disableGutters>
            <ListItemText>
              <Alert variant="outlined" severity="info">
                No items found
              </Alert>
            </ListItemText>
          </ListItem>
        )}
      </Box>
    </Box>
  );
};

export default EntityList;
